import { dismissNudge, nudgeMarkCompleted } from './createNudgeInfoBarViewState.locstring.json';
import {
    onNudgeInfoBarClicked,
    NudgeInfoBarResponse,
} from 'owa-mail-shared-actions/lib/onNudgeInfoBarClicked';
import loc from 'owa-localize';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import Message from 'owa-service/lib/contract/Message';
import { getNudgedReason, getNudgedRowKeyFromItemId } from 'owa-mail-nudge-store';
import {
    InfoBarCustomAction,
    InfoBarMessageColor,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

/**
 * Create the nudged info bar if necessary
 * @param message the message
 * @param key the key of info bar message
 * @param itemViewModel
 * @return the nudged InfoBarMessageViewState
 */
export default function createNudgeInfoBarViewState(
    message: Message,
    key: string,
    itemViewState: ItemViewState
): InfoBarMessageViewState {
    const rowKey = getNudgedRowKeyFromItemId(message.ItemId.Id);

    // If item is not a nudged item, then we should not render the nudge info bar.
    if (!rowKey) {
        return null;
    }

    const dismissAction: InfoBarCustomAction = {
        text: loc(dismissNudge),
        action: () => {
            onNudgeInfoBarClicked(rowKey, message.ItemId.Id, NudgeInfoBarResponse.Dismiss);
        },
    };

    const markCompletedAction: InfoBarCustomAction = {
        text: loc(nudgeMarkCompleted),
        action: () => {
            onNudgeInfoBarClicked(rowKey, message.ItemId.Id, NudgeInfoBarResponse.MarkComplete);
        },
    };

    return <InfoBarMessageViewState>{
        key: key,
        source: InfoBarMessageSource.ReadingPane,
        rank: InfoBarMessageRank.Info,
        messageParts: [getNudgedReason(rowKey), dismissAction, '|', markCompletedAction],
        textColor: InfoBarMessageColor.Green20,
        isMessageSemibold: true,
    };
}
